import {BaseTrading} from '../BaseFinancialInstruments/trading/BaseTrading';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {useState} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {Spin} from 'antd';
import {ConfirmModal} from 'pages/adminOpportunities/stocksListings/ViewOrders/HandleOrders';
import {
  currentInstrumentKey,
  financialInstrumentConfig,
} from '../modules/financialInstrumentConfig';

export const BondsTrading = () => {
  const location = useLocation();
  const {
    mutation,
    handleUpdate,
    route,
    handleDispatch,
    title,
    QUERY,
    overviewSelector,
  } = financialInstrumentConfig[currentInstrumentKey(location.pathname)];

  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [updatedValues, setUpdatedValues] = useState({});
  const navigate = useNavigate();
  const {assetId, lang, id} = useParams();
  const dispatch = useDispatch();
  const data = useSelector(overviewSelector);

  const [updateBond, {loading: loadingUpdate}] = useMutation(mutation);
  const {
    data: updateData,
    refetch,
    loading,
  } = useQuery(QUERY, {
    variables: {
      getFinancialInstrumentId: id,
      language: lang,
    },
    skip: !id,
  });

  const handleSubmit = values => {
    // eslint-disable-next-line no-unused-vars
    const {availableUnits, ...restValues} = values;
    if (id) {
      setOpenUpdateModal(true);
      setUpdatedValues(restValues);
    } else {
      dispatch(handleDispatch({...restValues}));
      navigate(route({param: assetId, name: 'overview'}));
    }
  };

  if (loading) {
    return (
      <div className="query-loading">
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div>
      <BaseTrading
        onSubmit={handleSubmit}
        existingValues={
          id ? updateData?.getFinancialInstrument?.data || {} : data
        }
      />
      <ConfirmModal
        openModal={openUpdateModal}
        setOpenModal={() => setOpenUpdateModal(false)}
        loading={loadingUpdate}
        title={`Update ${title}`}
        confirmText={`Are you sure you want update to this ${title}?`}
        handleOperation={() =>
          handleUpdate(
            updateBond,
            id,
            lang,
            updatedValues,
            refetch,
            setOpenUpdateModal,
          )
        }
      />
    </div>
  );
};
